import {createReducer} from '@reduxjs/toolkit';

import {setAuthTokensAction, setIsTokenExpiredAction, setUserDetailsAction} from 'store/actions/auth-action';
import {AuthState} from 'store/types/auth';

const initialState: AuthState = {
  isLoading: false,
  idToken: '',
  customerId: '',
  userDetails: null
};

const AuthReducer = createReducer(initialState, (builder) => {
  builder.addCase(setAuthTokensAction, (state, action) => {
    return {
      ...state,
      isLoading: false,
      ...(action?.payload || {})
    };
  });

  builder.addCase(setIsTokenExpiredAction, (state, action) => {
    return {
      ...state,
      isTokenExpired: action.payload
    };
  });

  builder.addCase(setUserDetailsAction, (state, action) => {
    return {
      ...state,
      userDetails: action.payload
    };
  });
});

export default AuthReducer;
